import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import Box from "@mui/material/Box";

function SoundLevelGauge({ deviceName, splValue }) {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null); // 用於存儲 ECharts 實例

  useEffect(() => {
    // 初始化 ECharts 實例
    const chartInstance = echarts.init(chartRef.current);
    chartInstanceRef.current = chartInstance; // 保存實例

    // 配置 Gauge 圖表的選項
    const option = {
      title: {
        text: `Sound Level - ${deviceName}`,
        left: "center",
        top: "2%",
        textStyle: {
          fontSize: 16,
        },
      },
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 120,
          splitNumber: 6,
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.3, "#67e0e3"], // Low noise
                [0.7, "#37a2da"], // Medium noise
                [1, "#fd666d"],   // High noise
              ],
            },
          },
          pointer: {
            itemStyle: {
              color: "auto",
            },
          },
          title: {
            offsetCenter: [0, "-30%"],
            fontSize: 14,
          },
          detail: {
            valueAnimation: true,
            formatter: "{value} dB",
            fontSize: 20,
          },
          data: [
            {
              value: splValue, // 初始值
              name: "dBA",
            },
          ],
        },
      ],
    };

    // 設置圖表選項
    chartInstance.setOption(option);

    // 清理函數
    return () => {
      chartInstance.dispose();
    };
  }, [deviceName]); // 僅在 deviceName 改變時重新初始化

  // 更新圖表數據
  useEffect(() => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.setOption({
        series: [
          {
            data: [
              {
                value: splValue, // 更新數據
                name: "dBA",
              },
            ],
          },
        ],
      });
    }
  }, [splValue]); // 當 splValue 改變時更新圖表

  return (
    <Box
      ref={chartRef}
      style={{ width: "100%", height: "400px" }} // 設置圖表大小
    ></Box>
  );
}

export default SoundLevelGauge;